<template>
  <teleport to="body">
    <iModal
      v-if="showReplyModal"
      :max-width="600"
      scrollable
      :show-footer="false"
      title="Reply in thread"
      @close="handleClose"
    >
      <template #body>
        <MessageThread
          :message-id="messageId"
          :context="context"
          :entity-id="entityId"
        />
      </template>
    </iModal>
  </teleport>
</template>

<script>
import MessageThread from "%/apps/conversations/components/message/MessageThread.vue";

export default {
  name: "ReplyMessageModal",
  components: {
    MessageThread,
  },
  props: {
    showReplyModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    messageId: {
      type: Number,
      required: true,
    },
    context: {
      type: String,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
  },
  emits: ["close"],
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>
